import { useTheme } from '@mui/material/styles';

export default function useNivoTheme() {
    const theme = useTheme();
    return {
        theme: {
            axis: {
                domain: { line: { stroke: theme.palette.custom.border.subtle } },
                ticks: {
                    line: { stroke: theme.palette.custom.border.subtle },
                    text: { fill: theme.palette.text.secondary, fontSize: 11, fontFamily: theme.typography.fontFamily },
                },
                legend: { text: { fill: theme.palette.text.secondary, fontSize: 12 } },
            },
            grid: { line: { stroke: theme.palette.custom.border.subtle } },
            crosshair: { line: { stroke: theme.palette.text.muted } },
            legends: { text: { fill: theme.palette.text.secondary } },
            labels: { text: { fill: '#ffffff', fontSize: 11 } },
        },
        colors: {
            primary: theme.palette.primary.main,
            success: theme.palette.success.main,
            error: theme.palette.error.main,
            buyFg: theme.palette.custom.direction.buyFg,
            sellFg: theme.palette.custom.direction.sellFg,
            muted: theme.palette.text.muted,
            secondary: theme.palette.text.secondary,
            democrat: '#3b82f6',
            republican: '#ef4444',
        },
        palette: theme.palette,
    };
}
